import React from 'react';
import PropTypes from 'prop-types';
import { withChildren } from '@builder.io/react/lite';
import styled from 'styled-components';

// todo: port over horizontal scroll
import HorizontalScroll from '@glowforge/gf-styled/src/components/horizontal-scroll';
// eslint-disable-next-line max-len
import { ScrollWrapper } from '@glowforge/gf-styled/src/components/horizontal-scroll/horizontal-scroll.styles';

const CarouselComponent = styled(HorizontalScroll).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    ['builder-id'].includes(prop) || defaultValidatorFn(prop),
})`
  padding: 0;

  ${ScrollWrapper} {
    padding: 20px;
  }

  /* This ensures that lazy loaded images load correctly inside of the carousel */
  picture {
    min-height: 1px;
  }

  // Remove stroke from arrows that is added by default
  // svg behavior
  & svg {
    stroke: ${(props) => props.theme.colors.white};
  }
`;

const ChildWrapper = styled('div')`
  display: flex;
`;

export const Carousel = ({ children, scrollStepMultiply }) => (
  <CarouselComponent scrollStepMultiply={scrollStepMultiply}>
    {React.Children.map(children, (child) => (
      <ChildWrapper>{child}</ChildWrapper>
    ))}
  </CarouselComponent>
);

Carousel.propTypes = {
  children: PropTypes.node,
  scrollStepMultiply: PropTypes.number,
};

Carousel.defaultProps = {
  children: null,
  scrollStepMultiply: 1,
};

export const BuilderCarousel = withChildren(Carousel);
export default BuilderCarousel;
